import { gql } from "@apollo/client";

export const GET_ROLES_BY_USER = gql`
    query rolesByUserId {
        rolesByUserId{
            id
            descripcion
        }
    }
`;